import axios, { AxiosPromise } from 'axios';

interface GetTokenResponse {
    status: number;
    userMessage: string;
    developerMessage: string;
    errorCode: string;
    moreInfo: null;
    data: {
        accessToken: string;
    };
}

export const tokenizerInstanceAxios = axios.create({
    headers: {
        apiKey: process.env.GATSBY_API_KEY,
        Authorization:
            typeof window !== 'undefined' &&
            `Bearer ${sessionStorage.getItem('tokenID')}`,
    },
});

tokenizerInstanceAxios.interceptors.response.use(
    function (response) {
        return response;
    },
    async function (error) {
        try {
            const tokenResponse = await getToken();
            const token = tokenResponse.data.data.accessToken;
            sessionStorage.setItem('tokenID', token);
            const newRequest = error.config;
            newRequest.headers = {
                ...newRequest.headers,
                Authorization: `Bearer ${token}`,
            };
            return axios.request(newRequest);
        } catch (error) {
            sessionStorage.removeItem('tokenID');
            throw error;
        }
    }
);

export const getToken: () => AxiosPromise<GetTokenResponse> = () => {
    const config = {
        method: 'get',
        url: `${process.env.GATSBY_URL_BASE_GENERAL}/tokenizer/accessToken`,
        headers: {
            apiKey: process.env.GATSBY_API_KEY_TOKENIZER,
        },
    };

    return axios.request(config);
};